import { FiX } from 'react-icons/fi'

import { formatDimensions } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import * as S from './styles'

const CardHeader = ({
  item,
  hasMultipleItems,
  currentIndex,
  total,
  onClose
}: CardHeaderProps) => {
  const { t } = useAPPTranslation()

  return (
    <S.CardHeader $centered={hasMultipleItems}>
      {hasMultipleItems && (
        <S.PositionIndicator>
          {t('rm:reviewAd.modal.position', {
            current: currentIndex + 1,
            total
          })}
        </S.PositionIndicator>
      )}

      <S.CardTitle>
        {formatDimensions(item.media_size || item.settings?.ad_size)}
      </S.CardTitle>

      <S.CloseButton
        type="button"
        onClick={onClose}
        aria-label={t('c:actions.close')}
      >
        <FiX />
      </S.CloseButton>
    </S.CardHeader>
  )
}

export default CardHeader
